import { OptionStr } from 'types/common/FormTypes';
import {
  ManageTagFormType,
  Tag,
  TagInProduct,
  TagOption,
  TagOptionStr,
  TagRequest,
} from 'types/tag/TagTypes';

export async function mapTagsToOptions(tags: Tag[]): Promise<OptionStr[]> {
  return tags.map((tag) => ({
    value: `${tag.id}`,
    label: `${tag.name}`,
  }));
}
export async function mapTagsToOptionsNumber(
  tags: Tag[]
): Promise<TagOption[]> {
  return tags.map((tag) => ({
    value: tag.id,
    label: `${tag.name}`,
    name: tag.name,
    color: tag.color,
  }));
}
export async function mapTagsToOptionsStr(
  tags: Tag[]
): Promise<TagOptionStr[]> {
  return tags.map((tag) => ({
    value: `${tag.id}`,
    label: `${tag.name}`,
    name: tag.name,
    color: tag.color,
  }));
}

export function mapTagsInProductToSelectOptions(
  tags: TagInProduct[]
): { value: string; label: string; color: string }[] {
  return tags.map((tag) => ({
    value: tag.id.toString(),
    label: tag.name,
    color: tag.color,
  }));
}

export function transformManageTagFormToRequest(
  formData: ManageTagFormType
): TagRequest {
  return {
    name: formData.name,
    type: formData.type,
    description: formData.description,
    color: formData.color,
    active: formData.active === 'true' || formData.active === '1' ? 1 : 0,
  };
}
